@include host-component-properties;

:host {
  --paf-search-form-column-gap-small-viewport: 12;
  --paf-search-form-column-gap-large-viewport: 16;
  --paf-search-form-row-gap-viewport: 16;
  --paf-search-form-from-to-switch-width-small-viewport: 48;
  --paf-search-form-from-to-switch-width-medium-viewport: 82;
  --paf-search-form-from-to-switch-width-large-viewport: 106;
  --paf-search-form-from-to-switch-width-xlarge-viewport: 145;
  --paf-search-form-buttons-padding-block: 40;
  --paf-search-form-input-max-height: 73;
  --paf-search-form-transition-duration-expand: 200ms;
  --paf-search-form-transition-duration-extend: 600ms;
  --paf-search-form-extended-block-margin-block-start: 32;
  --paf-search-form-extended-block-margin-block-end: 52;
  --paf-search-form-extended-block-border-width: var(--paf-global-border-width-2x);
  --paf-search-form-extended-block-border-color: var(--paf-global-post-brand-gray-20);
  --paf-search-form-extended-legend-font-size: 24;
  --paf-search-form-extended-legend-font-weight: 700;
  --paf-search-form-extended-legend-color: var(--paf-global-post-brand-dark);
  --paf-search-form-extended-via-margin-top: 72;
  --paf-search-form-extended-via-legend-margin-bottom: 16;
  --paf-search-form-extended-search-button-block-start-margin: -4;

  @include reduced-motion {
    --paf-search-form-transition-duration-expand: 0.01s;
    --paf-search-form-transition-duration-extend: 0.01s;
  }
}

.form {
  .from-to {
    display: grid;
    grid-template-columns: calc(100% - px-to-rem(var(--paf-search-form-from-to-switch-width-small-viewport)) - px-to-rem(var(--paf-search-form-column-gap-small-viewport))) px-to-rem(var(--paf-search-form-from-to-switch-width-small-viewport));
    column-gap: px-to-rem(var(--paf-search-form-column-gap-small-viewport));
    row-gap: px-to-rem(var(--paf-search-form-row-gap-viewport));

    paf-autocomplete {
      grid-area: 1 / 1 / 2 / 2;
    }

    paf-autocomplete:last-of-type {
      grid-area: 2 / 1 / 3 / 2;
    }

    paf-button.not-rotated {
      display: none;
    }

    paf-button {
      grid-area: 1 / 2 / 3 / 3;
    }

    @include mq($from: small) {
      grid-template-columns: 3fr px-to-rem(var(--paf-search-form-from-to-switch-width-medium-viewport)) 3fr;
      grid-template-rows: 1fr;
      grid-column-gap: px-to-rem(var(--paf-search-form-column-gap-large-viewport));

      paf-autocomplete {
        grid-area: 1 / 1 / 2 / 2;
      }

      paf-autocomplete:last-of-type {
        grid-area: 1 / 3 / 2 / 4;
      }

      paf-button.rotated {
        display: none;
      }

      paf-button.not-rotated {
        display: block;
      }

      paf-button {
        grid-area: 1 / 2 / 2 / 3;
        max-height: px-to-rem(var(--paf-search-form-input-max-height));
      }
    }

    @include mq($from: medium) {
      grid-template-columns: 3fr px-to-rem(var(--paf-search-form-from-to-switch-width-large-viewport)) 3fr;
    }

    @include mq($from: large) {
      grid-template-columns: 3fr px-to-rem(var(--paf-search-form-from-to-switch-width-xlarge-viewport)) 3fr;
    }
  }

  .date-time {
    display: grid;
    grid-template-rows: 0fr;
    opacity: 0;
    margin-block-start: 0;
    will-change: opacity, margin-block-start, grid-template-rows;
    transition-duration: var(--paf-search-form-transition-duration-expand);
    transition-property: opacity, margin-block-start, grid-template-rows;
    transition-timing-function: ease-out;
  }

  &.is-expanded {
    .date-time-container {
      overflow: visible;
    }

    .date-time {
      grid-template-rows: 1fr;
      opacity: 1;
      margin-block-start: px-to-rem(var(--paf-search-form-row-gap-viewport));
    }
  }

  .date-time-container {
    display: grid;
    grid-template-columns: calc(100% - px-to-rem(var(--paf-search-form-from-to-switch-width-small-viewport)) - px-to-rem(var(--paf-search-form-column-gap-small-viewport))) px-to-rem(var(--paf-search-form-from-to-switch-width-small-viewport));
    grid-template-rows: 1fr;
    column-gap: px-to-rem(var(--paf-search-form-column-gap-small-viewport));
    row-gap: px-to-rem(var(--paf-search-form-row-gap-viewport));
    overflow: hidden;

    paf-text-input {
      grid-area: 1 / 1 / 2 / 2;
    }

    paf-text-input:last-of-type {
      grid-area: 2 / 1 / 3 / 2;
    }

    paf-toggle-radio:first-of-type {
      display: none;
    }

    paf-toggle-radio:last-of-type {
      grid-area: 3 / 1 / 4 / 3;
    }

    @include mq($from: small) {
      grid-template-columns: repeat(2, 1.5fr) repeat(2, 0.5fr) repeat(2, 1.5fr);
      grid-template-rows: 1fr auto;
      grid-column-gap: px-to-rem(var(--paf-search-form-column-gap-large-viewport));
      row-gap: px-to-rem(var(--paf-search-form-row-gap-viewport));

      paf-text-input {
        grid-area: 1 / 1 / 2 / 3;
      }

      paf-text-input:last-of-type {
        grid-area: 1 / 5 / 2 / 7;
      }

      paf-toggle-radio:last-of-type {
        grid-area: 2 / 2 / 3 / 6;
      }
    }

    @include mq($from: medium) {
      grid-template-columns: 3fr px-to-rem(var(--paf-search-form-from-to-switch-width-large-viewport)) 3fr;
      grid-template-rows: 1fr;
      grid-column-gap: px-to-rem(var(--paf-search-form-column-gap-large-viewport));

      paf-text-input {
        grid-area: 1 / 1 / 2 / 2;
      }

      paf-text-input:last-of-type {
        grid-area: 1 / 3 / 2 / 4;
      }

      paf-toggle-radio:first-of-type {
        display: block;
        grid-area: 1 / 2 / 2 / 3;
      }

      paf-toggle-radio:last-of-type {
        display: none;
      }
    }

    @include mq($from: large) {
      grid-template-columns: 3fr px-to-rem(var(--paf-search-form-from-to-switch-width-xlarge-viewport)) 3fr;
    }
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    row-gap: px-to-rem(var(--paf-search-form-row-gap-viewport));
    margin-block-start: px-to-rem(var(--paf-search-form-buttons-padding-block));

    paf-button {
      flex-basis: 100%;
    }

    @include mq($from: small) {
      flex-wrap: nowrap;
      justify-content: space-between;

      paf-button {
        flex-basis: auto;
      }

      .extended-search-button {
        margin-left: px-to-rem(var(--paf-search-form-extended-search-button-block-start-margin));
      }
    }
  }

  .extended-search-container {
    display: grid;
    grid-template-rows: 0fr;
    opacity: 0;
    transition-duration: var(--paf-search-form-transition-duration-extend);
    will-change: opacity, grid-template-rows;
    transition-property: opacity, grid-template-rows;
    transition-timing-function: ease-in-out;
    overflow: hidden;
    padding-inline: px-to-rem(var(--paf-global-spacing-fixed-2x));
    margin-inline: px-to-rem(calc(var(--paf-global-spacing-fixed-2x) * -1));
    outline: none;

    &.is-extended {
      grid-template-rows: 1fr;
      opacity: 1;
    }

    &.is-extended .extended-search {
      visibility: visible;
    }
  }

  .extended-search {
    min-height: 0;
    transition: visibility 1s;
    visibility: hidden;

    .via-fieldset {
      @include reset-fieldset;

      scroll-margin-block-start: px-to-rem(var(--paf-global-spacing-fixed-8x));
      outline: 0;

      .legend {
        color: var(--paf-search-form-extended-legend-color);
        font-size: px-to-rem(var(--paf-search-form-extended-legend-font-size));
        font-weight: var(--paf-search-form-extended-legend-font-weight);
        margin-block-end: px-to-rem(var(--paf-search-form-extended-via-legend-margin-bottom));
      }
    }

    .extended-search-block {
      margin-block-start: px-to-rem(var(--paf-search-form-extended-block-margin-block-start));
      padding-block-end: px-to-rem(var(--paf-search-form-extended-block-margin-block-end));
      border-bottom: px-to-rem(var(--paf-search-form-extended-block-border-width)) solid var(--paf-search-form-extended-block-border-color);

      &:last-child {
        border-bottom: 0;
      }

      &.via-fieldset {
        margin-block-start: px-to-rem(var(--paf-search-form-extended-via-margin-top));
      }
    }
  }
}
